import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import * as styles from './_SubmitSpinner.scss'
import withStyles from 'isomorphic-style-loader/withStyles'

class SubmitSpinner extends Component {

  render () {
    return <FontAwesome
      className={styles['loading-spinner']}
      name='spinner'
      pulse />
  }
}

export default (SubmitSpinner)
